<div class="qr-code-component">
  <div class="qr-code-container">
    <div class="code-header">
      <h1>{{'QR_CODE_LETS_MOVE' | translate}}.</h1>
      <p>
       {{'QR_CODE_LOGIN_TEXT' | translate}}.
      </p>
    </div>
    <div class="qr-code">
      <span>
        <img src="./assets/icons/stg_store_QR.png" alt="qr code for downloading the HP PrintOS app" />
      </span>
    </div>
    <div class="code-footer">
      <a
        href="https://play.google.com/store/apps/details?id=com.merchant.reseller"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="./assets/icons/google-play.png" alt="play store link" />
      </a>
      <a
        href="https://itunes.apple.com/us/app/hp-printos-service-center/id1239517171?mt=8"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="./assets/icons/app-store.png" alt="app store link" />
      </a>
    </div>
  </div>
</div>
